import { Navigate, Outlet } from "react-router-dom";
import { useSignedInContext } from "../features/auth/useSignedInContext";

/** UX-level guard only — the server enforces this independently on every /api/v1 admin route. */
export function AdminGuard() {
  const { member } = useSignedInContext();
  if (member.role !== "admin") return <Navigate to="/" replace />;
  return <Outlet context={{ status: "signed-in", member } as const} />;
}
